import { Box } from '@mui/material';
import LogoutButton from './LogoutButton';

const AuthNavbar = () => (
  <Box sx={{ display: 'flex', justifyContent: 'end', pt: 1 }}>
    <LogoutButton />
  </Box>
);

export default AuthNavbar;
